export default "__VITE_ASSET__TXAG_twe__"